/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Intro_Title_1_PreInputs */

const tr_landing_intro_title_1_pre = /** @type {(inputs: Landing_Intro_Title_1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benzer yazılımlar sizden yılda`)
};

const en_landing_intro_title_1_pre = /** @type {(inputs: Landing_Intro_Title_1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Similar tools charge you`)
};

const de_landing_intro_title_1_pre = /** @type {(inputs: Landing_Intro_Title_1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vergleichbare Software verlangt von Ihnen`)
};

const ru_landing_intro_title_1_pre = /** @type {(inputs: Landing_Intro_Title_1_PreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Аналогичные программы требуют от вас`)
};

/**
* | output |
* | --- |
* | "Similar tools charge you" |
*
* @param {Landing_Intro_Title_1_PreInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const landing_intro_title_1_pre = /** @type {((inputs?: Landing_Intro_Title_1_PreInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Intro_Title_1_PreInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_intro_title_1_pre(inputs)
	if (locale === "de") return de_landing_intro_title_1_pre(inputs)
	if (locale === "ru") return ru_landing_intro_title_1_pre(inputs)
	return tr_landing_intro_title_1_pre(inputs)
});